import { lazy, Suspense } from 'react';
import { copyToClipboard } from '../CodeEasier';
import CopyIcon from '../svg/CopyIcon';

const FacebookShareButton = lazy(() => import('react-share').then(m => ({ default: m.FacebookShareButton })));
const FacebookIcon = lazy(() => import('react-share').then(m => ({ default: m.FacebookIcon })));

const WhatsappShareButton = lazy(() => import('react-share').then(m => ({ default: m.WhatsappShareButton })));
const WhatsappIcon = lazy(() => import('react-share').then(m => ({ default: m.WhatsappIcon })));

const TwitterShareButton = lazy(() => import('react-share').then(m => ({ default: m.TwitterShareButton })));
const TwitterIcon = lazy(() => import('react-share').then(m => ({ default: m.TwitterIcon })));

const LinkedinShareButton = lazy(() => import('react-share').then(m => ({ default: m.LinkedinShareButton })));
const LinkedinIcon = lazy(() => import('react-share').then(m => ({ default: m.LinkedinIcon })));

const TelegramShareButton = lazy(() => import('react-share').then(m => ({ default: m.TelegramShareButton })));
const TelegramIcon = lazy(() => import('react-share').then(m => ({ default: m.TelegramIcon })));

const ThreadsShareButton = lazy(() => import('react-share').then(m => ({ default: m.ThreadsShareButton })));
const ThreadsIcon = lazy(() => import('react-share').then(m => ({ default: m.ThreadsIcon })));

function LazyShareButtons({ className, url = window.location.href, quote = 'Check out this amazing website!' }) {
    return (

        <div className={className}>
            <Suspense fallback={<div>Loading share buttons...</div>}>

                <FacebookShareButton url={url} quote={quote} windowHeight={1000} windowWidth={1000}>
                    <FacebookIcon round />
                </FacebookShareButton>
                <WhatsappShareButton url={url} title={quote} windowWidth={1000} windowHeight={1000}>
                    <WhatsappIcon round />
                </WhatsappShareButton>
                <TwitterShareButton url={url} title={quote} windowWidth={1000} windowHeight={1000}>
                    <TwitterIcon round />
                </TwitterShareButton>
                <LinkedinShareButton url={url} title={quote} windowWidth={1000} windowHeight={1000}>
                    <LinkedinIcon round />
                </LinkedinShareButton>
                <TelegramShareButton url={url} title={quote} windowWidth={1000} windowHeight={1000}>
                    <TelegramIcon round />
                </TelegramShareButton>
                <ThreadsShareButton url={url} title={quote} windowWidth={1000} windowHeight={1000}>
                    <ThreadsIcon round />
                </ThreadsShareButton>
                <span className='copyIconSpan' onClick={() => copyToClipboard(url)}><CopyIcon /></span>
            </Suspense>
        </div>

    );
}


export default LazyShareButtons;
